import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "../../../../services/iconService";

const IconLicencePointsEight = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={{ ...sx }} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M166.558,139.779h-0.063c5.106-3.063,12.259-9.645,12.259-20.281c0-14.463-11.956-24.963-28.546-24.963
			c-17.063,0-28.747,10.5-28.747,24.963c0.102,8.406,4.659,16.127,11.971,20.281c-10.799,3.932-22.471,13.717-22.471,30.795
			c0,21.455,16.919,34.887,39.247,34.887c22.042,0,38.835-13.416,38.835-34.887C189.041,153.496,177.498,143.71,166.558,139.779z
			 M150.097,107.968c6.469-0.387,12.025,4.551,12.406,11.02c0.024,0.414,0.026,0.824,0.01,1.238c0,6.707-4.09,12.256-12.416,12.256
			s-12.545-5.549-12.545-12.256C137.552,113.882,141.644,107.968,150.097,107.968z M150.144,192.029h-0.047
			c-14.004,0-23.059-8.912-23.059-21.9c0-12.986,9.055-21.883,23.059-21.883c13.73,0,22.629,8.754,22.629,21.883
			C172.726,183.259,163.876,192.029,150.144,192.029z"
        />
        <path
          d="M29.485,287.126c-9.121-0.031-16.556-7.467-16.586-16.576V65.908c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.547,3.453,3.453v204.631c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.359,9.688-9.689
			V29.462c-0.018-5.318-4.367-9.666-9.697-9.68H29.496c-5.325,0.018-9.672,4.363-9.688,9.689v13.246
			c0,1.908-1.547,3.455-3.453,3.455c-1.908,0-3.455-1.547-3.455-3.455V29.46c0.03-9.117,7.459-16.551,16.563-16.586
			c0.008,0,0.017,0,0.022,0h241.018c9.126,0.021,16.566,7.457,16.598,16.576v241.088c-0.03,9.129-7.472,16.564-16.588,16.588H29.485
			z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.564H33.874c-1.907,0-3.454-1.547-3.454-3.455c0-1.906,1.547-3.453,3.454-3.453H262.67V33.847
			c0-1.906,1.547-3.453,3.454-3.453s3.454,1.547,3.454,3.453v232.262C269.578,268.017,268.03,269.564,266.124,269.564z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsEight;
